/**
 * Permission constants that match the backend Permissions.php constants
 * These should be kept in sync with Lib/Auth/Permissions.php
 */

export const PERMISSIONS = {

  // Job management
  JOB_MANAGE: 'job.manage',
  JOB_VIEW: 'job.view',
  JOB_UPDATE: 'job.update',
  JOB_DELETE: 'job.delete',
  JOB_CREATE: 'job.create',
  JOB_ASSIGN: 'job.assign',

  ZONE_MAP_MANAGE: 'zone_map.manage',

  // Appointment removal (unassign / move to Unscheduled / remove last tech / release orphan)
  APPOINTMENT_REMOVE: 'appointment.remove',

  // User and Role Management
  MANAGE_TENANT_ROLES: 'manage_tenant_roles',
  MANAGE_EMPLOYEE_ROLES: 'manage_employee_roles',
  MANAGE_USERS: 'manage_employees',
  // Employee private information (DOB, driver's license, fuel card, pay) on the Users page
  USER_PRIVATE_INFO_VIEW: 'user.private-info.view',
  USER_SMS_PREFERENCES_UPDATE: 'user.sms_preferences.update',
  USER_LOGIN_AS: 'user.login-as',
  FIELD_MANAGER_CRUD: 'field-manager.crud',
  CSR_MANAGER_CRUD: 'csr_manager.manage',

  // Customer Management
  CUSTOMER_VIEW: 'customer.view',
  CUSTOMER_CREATE: 'customer.create',
  CUSTOMER_UPDATE: 'customer.update',
  CUSTOMER_DELETE: 'customer.delete',
  CUSTOMER_ADDRESS_UPDATE: 'customer.address.update',
  CUSTOMER_SMS_PREFERENCES_UPDATE: 'customer.sms_preferences.update',
  CUSTOMER_CREATION_REPORT_VIEW: 'customer.creation_report.view',
  CUSTOMER_IMPORT: 'customer.import',
  CUSTOMER_IMPORT_ROLLBACK: 'customer.import.rollback',

  // call board
  CALL_BOARD_VIEW: 'call_board.view',
  CALL_BOARD_MANAGE: 'call_board.manage',

  // sms board
  SMS_BOARD_VIEW: 'sms_board.view',
  SMS_BOARD_MANAGE: 'sms_board.manage',
  SMS_BOARD_TEXT_ALL_TECHS: 'sms_board.text_all_techs.send',

  // Service Management
  MANAGE_SERVICES: 'manage_services',

  // Reporting
  VIEW_REPORTS: 'view_reports',

  // Zone Management
  MANAGE_ZONES: 'manage_zones',

  // Vehicle Management
  MANAGE_VEHICLES: 'manage_vehicles',

  // Inventory Management
  MANAGE_INVENTORY: 'manage_inventory',

  // Financial Management
  MANAGE_PAYMENTS: 'manage_payments',
  MANAGE_CONTRACTS: 'manage_contracts',

  // Document Management
  MANAGE_DOCUMENTS: 'manage_documents',

  // Communication
  MANAGE_NOTIFICATIONS: 'manage_notifications',

  // Integration Management
  MANAGE_INTEGRATIONS: 'manage_integrations',
  MANAGE_API_KEYS: 'manage_api_keys',
  MANAGE_WEBHOOKS: 'manage_webhooks',

  // Chat
  CHAT_VIEW: 'chat.view',
  CHAT_CHANNELS_MANAGE: 'chat.channels.manage',
  CHAT_USER_SYNC_MANAGE: 'chat.user_sync.manage',

  // Marketing (SMS Campaign service)
  MARKETING_DASHBOARD_VIEW: 'marketing.dashboard.view',
  MARKETING_CONTACTS_MANAGE: 'marketing.contacts.manage',
  MARKETING_LISTS_MANAGE: 'marketing.lists.manage',
  MARKETING_CAMPAIGNS_MANAGE: 'marketing.campaigns.manage',
  MARKETING_TEMPLATES_MANAGE: 'marketing.templates.manage',
  MARKETING_INBOX_MANAGE: 'marketing.inbox.manage',
  MARKETING_SUPPRESSIONS_MANAGE: 'marketing.suppressions.manage',
  MARKETING_SETTINGS_MANAGE: 'marketing.settings.manage',
  // Marketing > Social (Facebook Pages; Google Business Profile later)
  MARKETING_SOCIAL_ACCOUNTS_MANAGE: 'marketing.social_accounts.manage',
  MARKETING_SOCIAL_PLANNER_MANAGE: 'marketing.social_planner.manage',
  MARKETING_SOCIAL_PLANNER_SUBMIT: 'marketing.social_planner.submit',
  MARKETING_SOCIAL_PLANNER_APPROVE: 'marketing.social_planner.approve',
  MARKETING_SOCIAL_CONTENT_MANAGE: 'marketing.social_content.manage',
  MARKETING_SOCIAL_LEADS_MANAGE: 'marketing.social_leads.manage',
  MARKETING_SOCIAL_ADS_VIEW: 'marketing.social_ads.view',
  MARKETING_SOCIAL_ADS_MANAGE: 'marketing.social_ads.manage',
  MARKETING_SOCIAL_ADS_CREATE: 'marketing.social_ads.create',
  // Marketing > Google Business > Review Tracking (review credits per technician, badge / QR links)
  MARKETING_SOCIAL_REVIEW_TRACKING_VIEW: 'marketing.social_review_tracking.view',
  MARKETING_SOCIAL_REVIEW_TRACKING_MANAGE: 'marketing.social_review_tracking.manage',
  // Dispatch Details > Google Review tab: text the job's customer the review request
  MARKETING_SOCIAL_REVIEW_TRACKING_SEND_REQUEST: 'marketing.social_review_tracking.send_request',

  // System Administration
  MANAGE_AUDIT_LOGS: 'manage_audit_logs',
  MANAGE_BACKUPS: 'manage_backups',
  MANAGE_SYSTEM_HEALTH: 'manage_system_health',

  // GPS
  GPS_JOB_BOARD_VIEW: 'gps.job-board.view',
  GPS_JOB_NOTES_VIEW: 'gps.job-notes.view',
  GPS_JOB_NOTES_CREATE: 'gps.job-notes.create',
  GPS_JOB_NOTES_UPDATE: 'gps.job-notes.update',
  GPS_JOB_NOTES_DELETE: 'gps.job-notes.delete',
  GPS_JOB_STATUS_VIEW: 'gps.job-status.view',
  GPS_JOB_STATUS_CREATE: 'gps.job-status.create',
  GPS_JOB_STATUS_UPDATE: 'gps.job-status.update',
  GPS_JOB_STATUS_DELETE: 'gps.job-status.delete',
  GPS_DRIVER_DEVICE_VIEW: 'gps.driver-device.view',
  GPS_DRIVER_DEVICE_DOWN_SYNC: 'gps.driver-device.down-sync',
  GPS_DRIVER_DEVICE_UP_SYNC: 'gps.driver-device.up-sync',
  GPS_DRIVER_DEVICE_DAILY_SUMMARY_VIEW: 'gps.driver-device.daily-summary.view',
  GPS_DRIVER_DEVICE_DAILY_SUMMARY_CALCULATE: 'gps.driver-device.daily-summary.calculate',
  GPS_DRIVER_DEVICE_ROUTE_VIEW: 'gps.driver-device.route.view',
  GPS_DRIVER_DEVICE_DRIVE_STOP_VIEW: 'gps.driver-device.drive-stop.view',
  GPS_DRIVER_DEVICE_DRIVE_STOP_DOWN_SYNC: 'gps.driver-device.drive-stop.down-sync',
  GPS_DRIVER_DEVICE_ALERT_VIEW: 'gps.driver-device.alert.view',
  GPS_DRIVER_DEVICE_ALERT_DOWN_SYNC: 'gps.driver-device.alert.down-sync',
  GPS_DRIVER_DEVICE_DTC_VIEW: 'gps.driver-device.dtc.view',
  GPS_DRIVER_DEVICE_DTC_DOWN_SYNC: 'gps.driver-device.dtc.down-sync',
  GPS_DRIVER_DEVICE_GROUP_VIEW: 'gps.driver-device.group.view',
  GPS_DRIVER_DEVICE_GROUP_DOWN_SYNC: 'gps.driver-device.group.down-sync',
  GPS_DRIVER_DEVICE_OIL_CHANGE_VIEW: 'gps.driver-device.oil-change.view',
  GPS_DRIVER_DEVICE_OIL_CHANGE_COMPLETE: 'gps.driver-device.oil-change.complete',

  // Form
  FORM_VIEW: 'form.view',
  FORM_CREATE: 'form.create',
  FORM_UPDATE: 'form.update',
  FORM_DELETE: 'form.delete',
  FORM_EXPORT: 'form.export',
  FORM_IMPORT: 'form.import',
  FORM_FIELD_VIEW: 'form.field.view',
  FORM_FIELD_CREATE: 'form.field.create',
  FORM_FIELD_UPDATE: 'form.field.update',
  FORM_FIELD_DELETE: 'form.field.delete',
  FORM_RESPONSE_VIEW: 'form.response.view',
  FORM_RESPONSE_DELETE: 'form.response.delete',
  FORM_RESPONSE_EXPORT: 'form.response.export',
  FORM_RESPONSE_SUBMIT: 'form.response.submit',
  FORM_TRIGGER_VIEW: 'form.trigger.view',
  FORM_TRIGGER_CREATE: 'form.trigger.create',
  FORM_TRIGGER_UPDATE: 'form.trigger.update',
  FORM_TRIGGER_DELETE: 'form.trigger.delete',
  FORM_TRIGGER_EXECUTE: 'form.trigger.execute',

  // Invoice
  INVOICE_VIEW: 'invoice.view',
  INVOICE_CREATE: 'invoice.create',
  INVOICE_UPDATE: 'invoice.update',
  INVOICE_DELETE: 'invoice.delete',
  INVOICE_UPDATE_STATUS: 'invoice.update-status',
  INVOICE_SIGNNOW_START: 'invoice.signnow.start',
  // INVOICE_SIGNNOW_STATUS: 'invoice.signnow.status',
  // INVOICE_SIGNNOW_SESSIONS: 'invoice.signnow.sessions',
  INVOICE_SIGNNOW_SYNC: 'invoice.signnow.sync',

  // SignNow template documents
  SIGNNOW_TEMPLATES_MANAGE: 'signnow.templates.manage',
  SIGNNOW_DOCUMENTS_SEND: 'signnow.documents.send',
  EMPLOYEE_SIGNNOW_DOCUMENTS_SEND: 'employee.signnow.documents.send',

  INVOICE_TOP_CUSTOMERS: 'invoice.top-customers',
  INVOICE_PAYMENT_GATEWAYS_MANAGE: 'invoice.payment-gateways.manage',

  // Coupon
  COUPON_VIEW: 'coupon.view',
  COUPON_CREATE: 'coupon.create',
  COUPON_UPDATE: 'coupon.update',
  COUPON_DELETE: 'coupon.delete',

  // Sales Follow-ups
  SALES_VIEW: 'sales.view',
  SALES_UPDATE: 'sales.update',

  // Estimate
  ESTIMATE_VIEW: 'estimate.view',
  ESTIMATE_CREATE: 'estimate.create',
  ESTIMATE_UPDATE: 'estimate.update',
  ESTIMATE_DELETE: 'estimate.delete',
  ESTIMATE_EXPORT_PDF: 'estimate.export-pdf',

  // Pricebook
  PRICEBOOK_VIEW: 'pricebook.view',
  PRICEBOOK_CREATE: 'pricebook.create',
  PRICEBOOK_UPDATE: 'pricebook.update',
  PRICEBOOK_DELETE: 'pricebook.delete',
  PRICEBOOK_IMPORT: 'pricebook.import',

  // Pricebook Category
  PRICEBOOK_CATEGORY_VIEW: 'pricebook.category.view',
  PRICEBOOK_CATEGORY_CREATE: 'pricebook.category.create',
  PRICEBOOK_CATEGORY_UPDATE: 'pricebook.category.update',
  PRICEBOOK_CATEGORY_DELETE: 'pricebook.category.delete',

  // Memberships
  MEMBERSHIP_VIEW: 'membership.view',
  MEMBERSHIP_CREATE: 'membership.create',
  MEMBERSHIP_UPDATE: 'membership.update',
  MEMBERSHIP_MANAGE: 'membership.manage',

  // Email
  EMAIL_TEMPLATE_VIEW: 'email.template.view',
  EMAIL_TEMPLATE_CREATE: 'email.template.create',
  EMAIL_TEMPLATE_UPDATE: 'email.template.update',
  EMAIL_TEMPLATE_DELETE: 'email.template.delete',
  EMAIL_TEMPLATE_CATEGORY_MANAGE: 'email.template.category.manage',
  EMAIL_SIGNATURE_MANAGE: 'email.signature.manage',

  // Gmail Inbox
  GMAIL_INBOX_VIEW: 'gmail.inbox.view',
  GMAIL_INBOX_SEND: 'gmail.inbox.send',
  GMAIL_INBOX_MANAGE: 'gmail.inbox.manage',

  // CSR Numbers (shared-inbox number assignment)
  CSR_SUPPORT_MANAGE_NUMBERS: 'csr_support.manage_numbers',

  // CSR Availability Control
  CSR_AVAILABILITY_CONTROL: 'csr_availability_control',

  // Settings
  MANAGE_SETTINGS: 'manage_settings',
  MANAGE_MESSAGE_TEMPLATES: 'manage_message_templates',
  MANAGE_TENANT_ADDRESSES: 'manage_tenant_addresses',
  MANAGE_TENANT_INFO: 'manage_tenant_info',
  MANAGE_TEXT_NOTE_TEMPLATE: 'manage_text_note_template',
  MANAGE_TAXONOMY: 'manage_taxonomy',
  MANAGE_TECHNICIAN_AVAILABILITY: 'manage_technician_availability',
  // SMS Templates
  SMS_TEMPLATE_VIEW: 'sms-template.view',
  SMS_TEMPLATE_CREATE: 'sms-template.create',
  SMS_TEMPLATE_UPDATE: 'sms-template.update',
  SMS_TEMPLATE_DELETE: 'sms-template.delete',
  SMS_TEMPLATE_TRIGGER_VIEW: 'sms-template.trigger.view',
  SMS_TEMPLATE_TRIGGER_CREATE: 'sms-template.trigger.create',
  SMS_TEMPLATE_TRIGGER_UPDATE: 'sms-template.trigger.update',
  SMS_TEMPLATE_TRIGGER_DELETE: 'sms-template.trigger.delete',
  VEHICLE_POLICY_SMS_LOG_VIEW: 'vehicle-policy-sms-log.view',

  // Monitor
  VIEW_DISPATCH_GREETING_LOGS: 'view_dispatch_greeting_logs',
  VIEW_SIGNNOW_WEBHOOK_MONITOR: 'view_signnow_webhook_monitor',
  VIEW_LIVE_CALLS_MONITOR: 'view_live_calls_monitor',
  VIEW_FRONTDOOR_MONITOR: 'view_frontdoor_monitor',
  VIEW_SURVEY_FOLLOWUP_MONITOR: 'view_survey_followup_monitor',
  VIEW_NCC_FOLLOWUP_MONITOR: 'view_ncc_followup_monitor',
  VIEW_FIFTEEN_PLUS_MONITOR: 'view_fifteen_plus_monitor',
  HVAC_AGE_JOURNEY_VIEW: 'hvac_age_journey.view',
  HVAC_AGE_JOURNEY_MANAGE: 'hvac_age_journey.manage',
  ALL_CALLS_VIEW: 'all-calls.view',
  ALL_SMS_VIEW: 'all-sms.view',
  JOB_RECORDINGS_VIEW: 'job-recordings.view',
  JOB_RECORDINGS_EDIT: 'job-recordings.edit',
  JOB_RECORDING_UPLOADS_VIEW: 'job-recording-uploads.view',
  JOB_RECORDING_UPLOADS_MANAGE: 'job-recording-uploads.manage',
  MONITOR_LOGIN_AS_TECHNICIAN: 'monitor.login-as-technician.view',
  MONITOR_MOBILE_APP_LOGS_VIEW: 'monitor.mobile-app-logs.view',
  MONITOR_ESIGN_DOCUMENTS_VIEW: 'monitor.esign-documents.view',
  VIEW_AUDIT_TRAIL: 'view_audit_trail',
  VIEW_CUSTOMER_ROUTE_REMINDER_LOG: 'view_customer_route_reminder_log',
  NOTIFICATION_VIEW_ALL: 'notification.view_all',

  // CSR Performance dashboard (view-only — grantable broadly, e.g. to all CSRs)
  CSR_PERFORMANCE_VIEW: 'csr-performance.view',

  // CSR Productivity dashboard (manager-facing activity/time tracking);
  // TRACKING marks the users whose in-app activity is recorded
  CSR_PRODUCTIVITY_VIEW: 'csr-productivity.view',
  CSR_PRODUCTIVITY_TRACKING: 'csr-productivity.tracking',
  CSR_PRODUCTIVITY_MANAGE: 'csr-productivity.manage',

  // CSR clock sessions — manager override (view/edit/create/delete)
  CSR_CLOCK_MANAGE: 'csr-clock.manage',
  // Forced clock-in — the whole app is locked until the user clocks in
  CLOCKIN_REQUIRED: 'clockin.required',
  EMPLOYEE_CLOCK_VIEW: 'employee-clock.view',
  EMPLOYEE_CLOCK_MANAGE: 'employee-clock.manage',

  // Frontdoor Integration
  FRONTDOOR_NOTE_SHARE: 'frontdoor.note.share',

  // Technician Route Locking
  DISPATCH_ROUTE_LOCK_MANAGE: 'dispatch.route-lock.manage',

  // Archive a job / bring an archived job back (EDB detail panel + Job List)
  DISPATCH_ARCHIVE: 'dispatch.archive',
  // Edit the job notes shown as the description of a direct job (EDB detail panel)
  DISPATCH_DESCRIPTION_UPDATE: 'dispatch.description.update',

  // Technician Job Reports
  JOB_REPORT_REVIEW: 'dispatch.job-report.review',
  JOB_REPORT_DELETE: 'dispatch.job-report.delete',
  EMPLOYEE_JOB_REPORT_VIEW: 'employee.job-report.view',
  EMPLOYEE_JOB_REPORT_EQUIPMENT_PHOTO: 'employee.job-report.equipment-photo',
  // AI Reschedule Requests (Appointment Center AI Phone)
  RESCHEDULE_REQUEST_REVIEW: 'dispatch.reschedule-request.review',

  // Call Wrap-up (after-call work) — escalations raised by CSRs at wrap-up
  CALL_WRAPUP_ESCALATION_HANDLE: 'call_wrapup.escalation.handle',
  // Agent Status & Break Codes — supervisor view/override of CSR availability state
  AGENT_STATUS_MANAGE: 'agent_status.manage',
  // Call Handoff Monitor — appointments.center → CSR accept/bridge diagnostics
  CALL_HANDOFF_MONITOR_VIEW: 'call_handoff_monitor.view',

  // Employee Text Notes
  EMPLOYEE_TEXT_NOTE_VIEW: 'employee.text-note.view',
  EMPLOYEE_TEXT_NOTE_CREATE: 'employee.text-note.create',
  EMPLOYEE_TEXT_NOTE_UPDATE: 'employee.text-note.update',
  EMPLOYEE_TEXT_NOTE_DELETE: 'employee.text-note.delete',

  // Employee Comments
  EMPLOYEE_COMMENT_VIEW: 'employee.comment.view',
  EMPLOYEE_COMMENT_CREATE: 'employee.comment.create',
  EMPLOYEE_COMMENT_UPDATE: 'employee.comment.update',
  EMPLOYEE_COMMENT_DELETE: 'employee.comment.delete',

  // Employee Attachment Sharing
  EMPLOYEE_ATTACHMENT_SHARE_VIEW: 'employee.attachment.share.view',
  EMPLOYEE_ATTACHMENT_SHARE_CREATE: 'employee.attachment.share.create',
  EMPLOYEE_ATTACHMENT_SHARE_DELETE: 'employee.attachment.share.delete',

  // Time Log (Technician)
  TIMELOG_VIEW: 'timelog.view',
  TIMELOG_CREATE: 'timelog.create',
  TIMELOG_UPDATE: 'timelog.update',
  TIMELOG_DELETE: 'timelog.delete',

  // Jotform Integration
  JOTFORM_SETTINGS_VIEW: 'jotform.settings.view',
  JOTFORM_SETTINGS_UPDATE: 'jotform.settings.update',
  JOTFORM_FORMS_VIEW: 'jotform.forms.view',
  JOTFORM_FORMS_SYNC: 'jotform.forms.sync',
  JOTFORM_QUESTIONS_VIEW: 'jotform.questions.view',
  JOTFORM_QUESTIONS_SYNC: 'jotform.questions.sync',
  JOTFORM_SUBMISSIONS_VIEW: 'jotform.submissions.view',
  JOTFORM_SUBMISSIONS_SYNC: 'jotform.submissions.sync',
  JOTFORM_SUBMISSIONS_LINK: 'jotform.submissions.link',

  // Dispatch Followup
  DISPATCH_FOLLOWUP_VIEW: 'dispatch_followup.view',
  DISPATCH_FOLLOWUP_LOGS_VIEW: 'dispatch_followup.logs.view',
  DISPATCH_FOLLOWUP_TRIGGER: 'dispatch_followup.trigger',

  // Dispatch Appt Followup
  APPT_FOLLOWUP_VIEW: 'dispatch_appt_followup.view',
  APPT_FOLLOWUP_LOGS_VIEW: 'dispatch_appt_followup.logs.view',
  APPT_FOLLOWUP_TRIGGER: 'dispatch_appt_followup.trigger',

  // Technician Dashboard
  TECH_DASHBOARD_VIEW: 'tech_dashboard.view',
  TECH_DASHBOARD_KPI_EDIT: 'tech_dashboard.kpi.edit',
  TECH_DASHBOARD_CSR_SMS_LEADERBOARD_VIEW: 'tech_dashboard.csr_sms_leaderboard.view',

  // Executive Dashboard
  EXECUTIVE_DASHBOARD_VIEW: 'executive_dashboard.view',
  EXECUTIVE_TARGETS_MANAGE: 'executive_dashboard.targets.manage',

  // Automation Efficiency Dashboard
  AUTOMATION_DASHBOARD_VIEW: 'automation_dashboard.view',

  // Inventory > Parts List
  INVENTORY_PARTS_VIEW: 'inventory.parts.view',
  INVENTORY_PARTS_MANAGE: 'inventory.parts.manage',
} as const;

export type Permission = typeof PERMISSIONS[keyof typeof PERMISSIONS];

/**
 * Behavior-gating permissions that act ON the holder (tracking, lock-outs),
 * plus Log In As User, which is too sensitive to hand to every super admin.
 * The super-admin "has every permission" shortcut skips these — a super admin
 * holds one only via an explicit grant. Mirrors Permissions::EXPLICIT_GRANT_ONLY.
 */
export const EXPLICIT_GRANT_ONLY_PERMISSIONS: string[] = [
  PERMISSIONS.CSR_PRODUCTIVITY_TRACKING,
  PERMISSIONS.CLOCKIN_REQUIRED,
  PERMISSIONS.USER_LOGIN_AS,
];

/**
 * Permission groups for easier management
 */
export const PERMISSION_GROUPS = {
  USER_MANAGEMENT: [
    PERMISSIONS.MANAGE_TENANT_ROLES,
    PERMISSIONS.MANAGE_EMPLOYEE_ROLES,
    PERMISSIONS.MANAGE_USERS,
    PERMISSIONS.USER_PRIVATE_INFO_VIEW,
    PERMISSIONS.USER_LOGIN_AS,
    PERMISSIONS.FIELD_MANAGER_CRUD,
    PERMISSIONS.CSR_MANAGER_CRUD,
  ],
  BUSINESS_OPERATIONS: [
    PERMISSIONS.MANAGE_SERVICES,
    PERMISSIONS.JOB_MANAGE,
    PERMISSIONS.MANAGE_ZONES,
  ],
  CUSTOMER: [
    PERMISSIONS.CUSTOMER_VIEW,
    PERMISSIONS.CUSTOMER_CREATE,
    PERMISSIONS.CUSTOMER_UPDATE,
    PERMISSIONS.CUSTOMER_DELETE,
    PERMISSIONS.CUSTOMER_ADDRESS_UPDATE,
    PERMISSIONS.CUSTOMER_SMS_PREFERENCES_UPDATE,
    PERMISSIONS.CUSTOMER_CREATION_REPORT_VIEW,
    PERMISSIONS.CUSTOMER_IMPORT,
    PERMISSIONS.CUSTOMER_IMPORT_ROLLBACK,
  ],
  FINANCIAL: [
    PERMISSIONS.MANAGE_PAYMENTS,
    PERMISSIONS.MANAGE_CONTRACTS,
  ],
  SYSTEM_ADMIN: [
    PERMISSIONS.MANAGE_SETTINGS,
    PERMISSIONS.MANAGE_INTEGRATIONS,
    PERMISSIONS.MANAGE_API_KEYS,
    PERMISSIONS.MANAGE_WEBHOOKS,
    PERMISSIONS.MANAGE_AUDIT_LOGS,
    PERMISSIONS.MANAGE_BACKUPS,
    PERMISSIONS.MANAGE_SYSTEM_HEALTH,
  ],
  ASSETS: [
    PERMISSIONS.MANAGE_VEHICLES,
    PERMISSIONS.MANAGE_INVENTORY,
    PERMISSIONS.MANAGE_DOCUMENTS,
  ],
  COMMUNICATION: [
    PERMISSIONS.MANAGE_NOTIFICATIONS,
    PERMISSIONS.SMS_BOARD_TEXT_ALL_TECHS,
  ],
  REPORTING: [
    PERMISSIONS.VIEW_REPORTS,
  ],
  GPS: [
    PERMISSIONS.GPS_JOB_BOARD_VIEW,
    PERMISSIONS.GPS_JOB_NOTES_VIEW,
    PERMISSIONS.GPS_JOB_NOTES_CREATE,
    PERMISSIONS.GPS_JOB_NOTES_UPDATE,
    PERMISSIONS.GPS_JOB_NOTES_DELETE,
    PERMISSIONS.GPS_JOB_STATUS_VIEW,
    PERMISSIONS.GPS_JOB_STATUS_CREATE,
    PERMISSIONS.GPS_JOB_STATUS_UPDATE,
    PERMISSIONS.GPS_JOB_STATUS_DELETE,
    PERMISSIONS.GPS_DRIVER_DEVICE_VIEW,
    PERMISSIONS.GPS_DRIVER_DEVICE_DOWN_SYNC,
    PERMISSIONS.GPS_DRIVER_DEVICE_UP_SYNC,
    PERMISSIONS.GPS_DRIVER_DEVICE_DAILY_SUMMARY_VIEW,
    PERMISSIONS.GPS_DRIVER_DEVICE_DAILY_SUMMARY_CALCULATE,
    PERMISSIONS.GPS_DRIVER_DEVICE_ROUTE_VIEW,
    PERMISSIONS.GPS_DRIVER_DEVICE_DRIVE_STOP_VIEW,
    PERMISSIONS.GPS_DRIVER_DEVICE_DRIVE_STOP_DOWN_SYNC,
    PERMISSIONS.GPS_DRIVER_DEVICE_ALERT_VIEW,
    PERMISSIONS.GPS_DRIVER_DEVICE_ALERT_DOWN_SYNC,
    PERMISSIONS.GPS_DRIVER_DEVICE_DTC_VIEW,
    PERMISSIONS.GPS_DRIVER_DEVICE_DTC_DOWN_SYNC,
    PERMISSIONS.GPS_DRIVER_DEVICE_GROUP_VIEW,
    PERMISSIONS.GPS_DRIVER_DEVICE_GROUP_DOWN_SYNC,
    PERMISSIONS.GPS_DRIVER_DEVICE_OIL_CHANGE_VIEW,
    PERMISSIONS.GPS_DRIVER_DEVICE_OIL_CHANGE_COMPLETE,
  ],
  FORM: [
    PERMISSIONS.FORM_VIEW,
    PERMISSIONS.FORM_CREATE,
    PERMISSIONS.FORM_UPDATE,
    PERMISSIONS.FORM_DELETE,
    PERMISSIONS.FORM_EXPORT,
    PERMISSIONS.FORM_IMPORT,
    PERMISSIONS.FORM_FIELD_VIEW,
    PERMISSIONS.FORM_FIELD_CREATE,
    PERMISSIONS.FORM_FIELD_UPDATE,
    PERMISSIONS.FORM_FIELD_DELETE,
    PERMISSIONS.FORM_RESPONSE_VIEW,
    PERMISSIONS.FORM_RESPONSE_DELETE,
    PERMISSIONS.FORM_RESPONSE_EXPORT,
    PERMISSIONS.FORM_RESPONSE_SUBMIT,
    PERMISSIONS.FORM_TRIGGER_VIEW,
    PERMISSIONS.FORM_TRIGGER_CREATE,
    PERMISSIONS.FORM_TRIGGER_UPDATE,
    PERMISSIONS.FORM_TRIGGER_DELETE,
    PERMISSIONS.FORM_TRIGGER_EXECUTE,
  ],
  INVOICE: [
    PERMISSIONS.INVOICE_VIEW,
    PERMISSIONS.INVOICE_CREATE,
    PERMISSIONS.INVOICE_UPDATE,
    PERMISSIONS.INVOICE_DELETE,
    PERMISSIONS.INVOICE_UPDATE_STATUS,
    // PERMISSIONS.INVOICE_ESIGN_START,
    // PERMISSIONS.INVOICE_ESIGN_STATUS,
    PERMISSIONS.INVOICE_SIGNNOW_START,
    // PERMISSIONS.INVOICE_SIGNNOW_STATUS,
    // PERMISSIONS.INVOICE_SIGNNOW_SESSIONS,
    PERMISSIONS.INVOICE_SIGNNOW_SYNC,
    PERMISSIONS.INVOICE_TOP_CUSTOMERS,
    PERMISSIONS.INVOICE_PAYMENT_GATEWAYS_MANAGE,
  ],
  ESIGN_DOCUMENTS: [
    PERMISSIONS.SIGNNOW_TEMPLATES_MANAGE,
    PERMISSIONS.SIGNNOW_DOCUMENTS_SEND,
    PERMISSIONS.EMPLOYEE_SIGNNOW_DOCUMENTS_SEND,
  ],
  COUPON: [
    PERMISSIONS.COUPON_VIEW,
    PERMISSIONS.COUPON_CREATE,
    PERMISSIONS.COUPON_UPDATE,
    PERMISSIONS.COUPON_DELETE,
  ],
  SALES: [
    PERMISSIONS.SALES_VIEW,
    PERMISSIONS.SALES_UPDATE,
  ],
  ESTIMATE: [
    PERMISSIONS.ESTIMATE_VIEW,
    PERMISSIONS.ESTIMATE_CREATE,
    PERMISSIONS.ESTIMATE_UPDATE,
    PERMISSIONS.ESTIMATE_DELETE,
    PERMISSIONS.ESTIMATE_EXPORT_PDF,
  ],
  PRICEBOOK: [
    PERMISSIONS.PRICEBOOK_VIEW,
    PERMISSIONS.PRICEBOOK_CREATE,
    PERMISSIONS.PRICEBOOK_UPDATE,
    PERMISSIONS.PRICEBOOK_DELETE,
    PERMISSIONS.PRICEBOOK_IMPORT,
    PERMISSIONS.PRICEBOOK_CATEGORY_VIEW,
    PERMISSIONS.PRICEBOOK_CATEGORY_CREATE,
    PERMISSIONS.PRICEBOOK_CATEGORY_UPDATE,
    PERMISSIONS.PRICEBOOK_CATEGORY_DELETE,
  ],
  GMAIL_INBOX: [
    PERMISSIONS.GMAIL_INBOX_VIEW,
    PERMISSIONS.GMAIL_INBOX_SEND,
    PERMISSIONS.GMAIL_INBOX_MANAGE,
  ],
  EMAIL: [
    PERMISSIONS.EMAIL_TEMPLATE_VIEW,
    PERMISSIONS.EMAIL_TEMPLATE_CREATE,
    PERMISSIONS.EMAIL_TEMPLATE_UPDATE,
    PERMISSIONS.EMAIL_TEMPLATE_DELETE,
    PERMISSIONS.EMAIL_TEMPLATE_CATEGORY_MANAGE,
    PERMISSIONS.EMAIL_SIGNATURE_MANAGE,
  ],
  SETTINGS: [
    PERMISSIONS.MANAGE_SETTINGS,
    PERMISSIONS.MANAGE_MESSAGE_TEMPLATES,
    PERMISSIONS.MANAGE_TENANT_ADDRESSES,
    PERMISSIONS.MANAGE_TENANT_INFO,
    PERMISSIONS.MANAGE_TEXT_NOTE_TEMPLATE,
    PERMISSIONS.MANAGE_TAXONOMY,
  ],
  SMS_TEMPLATES: [
    PERMISSIONS.SMS_TEMPLATE_VIEW,
    PERMISSIONS.SMS_TEMPLATE_CREATE,
    PERMISSIONS.SMS_TEMPLATE_UPDATE,
    PERMISSIONS.SMS_TEMPLATE_DELETE,
    PERMISSIONS.SMS_TEMPLATE_TRIGGER_VIEW,
    PERMISSIONS.SMS_TEMPLATE_TRIGGER_CREATE,
    PERMISSIONS.SMS_TEMPLATE_TRIGGER_UPDATE,
    PERMISSIONS.SMS_TEMPLATE_TRIGGER_DELETE,
  ],
  MONITOR: [
    PERMISSIONS.VIEW_DISPATCH_GREETING_LOGS,
    PERMISSIONS.VIEW_SIGNNOW_WEBHOOK_MONITOR,
    PERMISSIONS.VIEW_LIVE_CALLS_MONITOR,
    PERMISSIONS.VIEW_FRONTDOOR_MONITOR,
    PERMISSIONS.VIEW_SURVEY_FOLLOWUP_MONITOR,
    PERMISSIONS.VIEW_NCC_FOLLOWUP_MONITOR,
    PERMISSIONS.VIEW_FIFTEEN_PLUS_MONITOR,
    PERMISSIONS.HVAC_AGE_JOURNEY_VIEW,
    PERMISSIONS.HVAC_AGE_JOURNEY_MANAGE,
    PERMISSIONS.ALL_CALLS_VIEW,
    PERMISSIONS.ALL_SMS_VIEW,
    PERMISSIONS.JOB_RECORDINGS_VIEW,
    PERMISSIONS.JOB_RECORDINGS_EDIT,
    PERMISSIONS.JOB_RECORDING_UPLOADS_VIEW,
    PERMISSIONS.JOB_RECORDING_UPLOADS_MANAGE,
    PERMISSIONS.MONITOR_LOGIN_AS_TECHNICIAN,
    PERMISSIONS.MONITOR_MOBILE_APP_LOGS_VIEW,
    PERMISSIONS.MONITOR_ESIGN_DOCUMENTS_VIEW,
    PERMISSIONS.VIEW_AUDIT_TRAIL,
    PERMISSIONS.VIEW_CUSTOMER_ROUTE_REMINDER_LOG,
  ],
  CSR_PERFORMANCE: [
    PERMISSIONS.CSR_PERFORMANCE_VIEW,
    PERMISSIONS.CSR_PRODUCTIVITY_VIEW,
    PERMISSIONS.CSR_PRODUCTIVITY_TRACKING,
    PERMISSIONS.CSR_PRODUCTIVITY_MANAGE,
    PERMISSIONS.CSR_CLOCK_MANAGE,
    PERMISSIONS.CLOCKIN_REQUIRED,
  ],
  EMPLOYEE_CLOCK: [
    PERMISSIONS.EMPLOYEE_CLOCK_VIEW,
    PERMISSIONS.EMPLOYEE_CLOCK_MANAGE,
  ],
  EMPLOYEE_TEXT_NOTES: [
    PERMISSIONS.EMPLOYEE_TEXT_NOTE_VIEW,
    PERMISSIONS.EMPLOYEE_TEXT_NOTE_CREATE,
    PERMISSIONS.EMPLOYEE_TEXT_NOTE_UPDATE,
    PERMISSIONS.EMPLOYEE_TEXT_NOTE_DELETE,
  ],
  EMPLOYEE_COMMENTS: [
    PERMISSIONS.EMPLOYEE_COMMENT_VIEW,
    PERMISSIONS.EMPLOYEE_COMMENT_CREATE,
    PERMISSIONS.EMPLOYEE_COMMENT_UPDATE,
    PERMISSIONS.EMPLOYEE_COMMENT_DELETE,
  ],
  EMPLOYEE_ATTACHMENT_SHARING: [
    PERMISSIONS.EMPLOYEE_ATTACHMENT_SHARE_VIEW,
    PERMISSIONS.EMPLOYEE_ATTACHMENT_SHARE_CREATE,
    PERMISSIONS.EMPLOYEE_ATTACHMENT_SHARE_DELETE,
  ],
  TIMELOG: [
    PERMISSIONS.TIMELOG_VIEW,
    PERMISSIONS.TIMELOG_CREATE,
    PERMISSIONS.TIMELOG_UPDATE,
    PERMISSIONS.TIMELOG_DELETE,
  ],
  CSR_SUPPORT: [
    PERMISSIONS.CSR_SUPPORT_MANAGE_NUMBERS,
    PERMISSIONS.CSR_AVAILABILITY_CONTROL,
  ],
  CALL_WRAPUP: [
    PERMISSIONS.CALL_WRAPUP_ESCALATION_HANDLE,
    PERMISSIONS.AGENT_STATUS_MANAGE,
    PERMISSIONS.CALL_HANDOFF_MONITOR_VIEW,
  ],
  JOTFORM: [
    PERMISSIONS.JOTFORM_SETTINGS_VIEW,
    PERMISSIONS.JOTFORM_SETTINGS_UPDATE,
    PERMISSIONS.JOTFORM_FORMS_VIEW,
    PERMISSIONS.JOTFORM_FORMS_SYNC,
    PERMISSIONS.JOTFORM_QUESTIONS_VIEW,
    PERMISSIONS.JOTFORM_QUESTIONS_SYNC,
    PERMISSIONS.JOTFORM_SUBMISSIONS_VIEW,
    PERMISSIONS.JOTFORM_SUBMISSIONS_SYNC,
    PERMISSIONS.JOTFORM_SUBMISSIONS_LINK,
  ],
  DISPATCH_FOLLOWUP: [
    PERMISSIONS.DISPATCH_FOLLOWUP_VIEW,
    PERMISSIONS.DISPATCH_FOLLOWUP_LOGS_VIEW,
    PERMISSIONS.DISPATCH_FOLLOWUP_TRIGGER,
  ],
  APPT_FOLLOWUP: [
    PERMISSIONS.APPT_FOLLOWUP_VIEW,
    PERMISSIONS.APPT_FOLLOWUP_LOGS_VIEW,
    PERMISSIONS.APPT_FOLLOWUP_TRIGGER,
  ],
  MARKETING: [
    PERMISSIONS.MARKETING_DASHBOARD_VIEW,
    PERMISSIONS.MARKETING_CONTACTS_MANAGE,
    PERMISSIONS.MARKETING_LISTS_MANAGE,
    PERMISSIONS.MARKETING_CAMPAIGNS_MANAGE,
    PERMISSIONS.MARKETING_TEMPLATES_MANAGE,
    PERMISSIONS.MARKETING_INBOX_MANAGE,
    PERMISSIONS.MARKETING_SUPPRESSIONS_MANAGE,
    PERMISSIONS.MARKETING_SETTINGS_MANAGE,
    PERMISSIONS.MARKETING_SOCIAL_ACCOUNTS_MANAGE,
    PERMISSIONS.MARKETING_SOCIAL_PLANNER_MANAGE,
    PERMISSIONS.MARKETING_SOCIAL_PLANNER_SUBMIT,
    PERMISSIONS.MARKETING_SOCIAL_PLANNER_APPROVE,
    PERMISSIONS.MARKETING_SOCIAL_CONTENT_MANAGE,
    PERMISSIONS.MARKETING_SOCIAL_LEADS_MANAGE,
    PERMISSIONS.MARKETING_SOCIAL_ADS_VIEW,
    PERMISSIONS.MARKETING_SOCIAL_ADS_MANAGE,
    PERMISSIONS.MARKETING_SOCIAL_ADS_CREATE,
    PERMISSIONS.MARKETING_SOCIAL_REVIEW_TRACKING_VIEW,
    PERMISSIONS.MARKETING_SOCIAL_REVIEW_TRACKING_MANAGE,
    PERMISSIONS.MARKETING_SOCIAL_REVIEW_TRACKING_SEND_REQUEST,
  ],
} as const;
